import styled from 'styled-components'

import theme from 'theme_'
import { WhiteBlock } from 'components/Layout'

const { spacing } = theme

export const SubInfoContainer = styled.section`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 16px;
`

export const SubInfoBlock = styled(WhiteBlock)<{ $isChild?: boolean }>`
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 100%;
  padding: ${spacing.s} ${spacing.base} ${spacing.sm};

  @media ${theme.devices.tablet} {
    flex-basis: 48%;
  }
  @media ${theme.devices.desktop} {
    padding: ${spacing.base} ${spacing.md} ${spacing.md};
    flex-basis: ${(p) => (p.$isChild ? '50%' : '32%')};
    box-shadow: none;
  }
`

export const SubInfoBody = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`
